// extracted by mini-css-extract-plugin
export default {"hospitals_wrapper":"CreateJob_hospitals_wrapper__9Unw7","main_wrapper":"CreateJob_main_wrapper__ilIdj"};